import styled from 'styled-components'

export const Content = styled.div`
  margin: 0 auto;
  max-width: 70rem;
  text-align: center;

  h1,
  h2,
  h3 {
    line-height: 1.25;
    margin: 0 0 1.6rem 0;
    text-transform: capitalize;

    &:after {
      content: '';
      display: block;
      height: 1px;
      background-color: ${props => props.theme.colors.cobalt};
      max-width: 27rem;
      margin: 1.6rem auto 2rem;
    }
  }

  h1 {
    font-size: 6.4rem;
  }
  h2 {
    font-size: 4rem;
  }
  h3 {
    font-size: 3.6rem;
  }

  p {
    margin: 0 0 2em 0;
  }

  a {
    transition: 0.2s;
    color: ${props => props.theme.colors.base};
    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
  }

  del {
    text-decoration: line-through;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 0 0 2em 0;
  }

  ul {
    li {
      font-size: 1.6rem;
      list-style: disc;
      list-style-position: inside;
      line-height: 1.25;
      &:last-child {
        margin: 0;
      }
    }
  }

  ol {
    li {
      font-size: 1.6rem;
      list-style: decimal;
      list-style-position: inside;
      line-height: 1.25;
      &:last-child {
        margin: 0;
      }
    }
  }

  hr {
    border-style: solid;
    border-color: ${props => props.theme.colors.secondary};
    margin: 0 0 2em 0;
  }

  blockquote {
    font-size: 1.6rem;
    font-style: italic;
    border-left: 4px solid ${props => props.theme.colors.secondary};
    padding: 0 0 0 0.5em;
  }

  pre {
    font-size: 1.4rem;
    margin: 0 0 2em 0;
    border-radius: 2px;
    background: ${props => props.theme.colors.secondary} !important;
    span {
      background: inherit !important;
    }
  }
`
